export default __webpack_public_path__ + "static/media/return.6f788969.svg";